import {ModalPolicyUpdateHandler} from 'types'

let handler: ModalPolicyUpdateHandler | undefined

export function setModalPolicyUpdateHandler(
  instance: ModalPolicyUpdateHandler,
) {
  handler = instance
}

export function showModalPolicyUpdate() {
  handler && handler.showModal()
}
